const getDefaultState = () => {
  return {
    codeStepParams: null,
    finallStepPageType: null,
  };
};

export default {
  state: getDefaultState(),
  getters: {
    getCodeStepParams: (state) => state.codeStepParams,
    getFinallStepPageType: (state) => state.finallStepPageType,
  },
  mutations: {
    MUTATE_CODE_STEP_PARAMS(state, value) {
      state.codeStepParams = { ...value };
    },
    MUTATE_FINALL_STEP_PAGE_TYPE(state, value) {
      state.finallStepPageType = value;
    },
    RESET_REG_PAGES_PARAMS(state) {
      Object.assign(state, getDefaultState());
    },
  },
  actions: {},
};
